import { useEffect, useState } from "react";
import { Dropdown } from "../resources/assetsManager";
import { WHITE_COLOR } from "../resources/colorsManager";
import { IoRefreshSharp } from "react-icons/io5";

const CustomViewModal = ({ closeModal, data, onClickRefresh }) => {
  const [keys, setKeys] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    let temp = Object.keys(data);
    let temp1 = Object.values(data);
    setKeys(temp);
    setValues(temp1);
  }, [data]);
  return (
    <div>
      <div
        style={{
          position: "fixed",
          display: "flex",
          justifyContent: "center",
          width: "60%",
          top: 0,
          backgroundColor: WHITE_COLOR,
        }}
      >
        <p
          style={{
            color: "black",
            fontSize: "22px",
            margin: "28px 0px 30px 0px",
            textAlign: "center",
          }}
          className="roboto"
        >
          {" "}
          {"Transaction Details"}
        </p>

        <div
          style={{
            backgroundColor: "#E5E5E5",
            width: "36px",
            height: "36px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            left: "30px",
            top: "25px",
            borderRadius: "8px",
            cursor: "pointer",
          }}
          onClick={() => {
            closeModal();
          }}
        >
          <img
            src={Dropdown}
            style={{ transform: "rotate(270deg)" }}
            alt="Arrow"
          />
        </div>
      </div>

      <div
        style={{
          marginTop: 100,
        }}
      >
        {keys &&
          keys.map((item, index) => {
            return (
              <>
                {!Array.isArray(values[index]) && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      paddingBottom: 15,
                      paddingTop: 15,
                      width: "100%",
                      padding: "15px 30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <span
                        style={{ color: "black", minWidth: 220, fontSize: 16 }}
                      >
                        {" "}
                        {Array.isArray(values[index]) ? "" : keys[index]}
                      </span>
                    </div>
                    <div
                      style={{
                        flexWrap: "wrap",
                        wordBreak: "break-all",
                        alignItems: "center",
                        justifyContent: "center",
                        maxWidth: 300,
                      }}
                    >
                      <span
                        style={{
                          marginLeft: 0,
                          minWidth: 200,
                          color: "black",
                          fontSize: "16px",
                        }}
                      >
                        {Array.isArray(values[index]) ? "" : values[index]}
                      </span>
                      {/* {values[index] === "SUCCESS" && (
                      <IoRefreshSharp
                        size={15}
                        color="black"
                        style={{
                          marginLeft: 8,
                          marginTop: 4,
                          cursor: "pointer",
                        }}
                        onClick={() => onClickRefresh(values[1])}
                      />
                    )} */}
                    </div>
                  </div>
                )}
              </>
            );
          })}
      </div>
    </div>
  );
};

export default CustomViewModal;
